import React, { useContext } from "react";
import { useParams, useHistory } from "react-router-dom";
import { useGameQuery } from "../../hooks/useGameQuery";
import { Game } from "./Game";
import gameData from "./dummy-data";
import { GameContextProvider } from "../GameContext";
import { PlayerContextProvider } from "../CurrentPlayerContext";
import { UserContext } from "../UserContext";
import LoadingIndicator from "../LoadingIndicator";
import JoinGameErrorModal from "../modal/joinErrorModal";
import { motion } from "framer-motion";

const Play = () => {
  const { user } = useContext(UserContext);
  const { id } = useParams();
  const [game, loading] = useGameQuery(id);
  const history = useHistory();

  const loadedGameData = () => {
    let gameId = game?.questionSet;

    if (gameId) {
      if (gameId >= 0) {
        let questionSetData = require(`../../data/questionSet_${gameId}.json`);
        return questionSetData;
      }
    }

    return gameData;
  };

  return (
    <motion.div className="w-full flex justify-center" exit={{}}>
      {loading && <LoadingIndicator />}
      {game && (
        <GameContextProvider
          game={game}
          playerId={user.id}
          totalRounds={gameData.length}
        >
          <PlayerContextProvider game={game} playerId={user.id}>
            <Game gameData={loadedGameData()} />
          </PlayerContextProvider>
        </GameContextProvider>
      )}
      {!loading && !game && (
        <JoinGameErrorModal
          errorMsg="Woops Something went Wrong"
          createGame={() => history.push("/")}
        />
      )}
    </motion.div>
  );
};
export default Play;
